/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Results = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <path d="M13,9 C13,9.552 12.552,10 12,10 L8,10 C7.448,10 7,9.552 7,9 C7,8.448 7.448,8 8,8 L12,8 C12.552,8 13,8.448 13,9 L13,9 Z M13,5 C13,5.552 12.552,6 12,6 L8,6 C7.448,6 7,5.552 7,5 C7,4.448 7.448,4 8,4 L12,4 C12.552,4 13,4.448 13,5 L13,5 Z M18,4 L17,4 L17,3 C17,2.449 17.449,2 18,2 C18.551,2 19,2.449 19,3 C19,3.551 18.551,4 18,4 L18,4 Z M15,17 C15,17.551 14.551,18 14,18 C13.449,18 13,17.551 13,17 L13,15 C13,14.448 12.552,14 12,14 L5,14 L5,4 C5,2.897 5.897,2 7,2 L15.184,2 C15.071,2.313 15,2.647 15,3 L15,17 Z M5,18 C3.897,18 3,17.103 3,16 L11,16 L11,17 C11,17.351 11.061,17.687 11.171,18 L5,18 Z M18,0 L7,0 C4.794,0 3,1.794 3,4 L3,14 L2,14 C1.448,14 1,14.448 1,15 L1,16 C1,18.206 2.794,20 5,20 L14,20 L14.001,20 C15.655,19.999 17,18.654 17,17 L17,6 L18,6 C19.654,6 21,4.654 21,3 C21,1.346 19.654,0 18,0 L18,0 Z" />
    </BaseSvgIcon>
  )
}

export default Results
